import styled from 'styled-components';

export const GridModal = styled.div`
  display: grid;
  grid-template-columns: 200px 490px 100px;
  column-gap: 15px;
`;
